exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PatientConsentForMedicalRecordsExchange--1KAI_9cbdHdn7TV1kNTc_k {\n  background: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);

// exports
exports.locals = {
	"loader": "PatientConsentForMedicalRecordsExchange--1KAI_9cbdHdn7TV1kNTc_k",
	"loader": "PatientConsentForMedicalRecordsExchange--1KAI_9cbdHdn7TV1kNTc_k"
};